import { render, staticRenderFns } from "./TenancyHeader.vue?vue&type=template&id=b5c04b3c&scoped=true&"
import script from "./TenancyHeader.vue?vue&type=script&lang=js&"
export * from "./TenancyHeader.vue?vue&type=script&lang=js&"
import style0 from "./TenancyHeader.vue?vue&type=style&index=0&id=b5c04b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c04b3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5c04b3c')) {
      api.createRecord('b5c04b3c', component.options)
    } else {
      api.reload('b5c04b3c', component.options)
    }
    module.hot.accept("./TenancyHeader.vue?vue&type=template&id=b5c04b3c&scoped=true&", function () {
      api.rerender('b5c04b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/TenancyHeader.vue"
export default component.exports